/**
 * 타이포그래피 공통 컴포넌트
 *
 * 페이지·섹션 제목, 부제목, 레이블, 에러 텍스트 등
 * 자주 사용하는 텍스트 스타일을 제공한다.
 */

import { styled } from 'styled-components';

// ─────────────────────────────────────────────────────────────
// 제목
// ─────────────────────────────────────────────────────────────

/** 페이지 최상단 제목 (h1) */
export const PageTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  line-height: 57px;
  color: ${({ theme }) => theme.colors.fontBlackText};
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 36px;
    line-height: 44px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 28px;
    line-height: 36px;
  }
`;

/** 섹션 제목 (h2) */
export const SectionTitle = styled.h2<{ $isFirst?: boolean; margin?: string }>`
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  color: ${({ theme }) => theme.colors.fontBlackText};
  margin: ${({ margin }) => margin || '0'};
  margin-bottom: ${({ $isFirst }) => ($isFirst ? 0 : 16)}px;
`;

/** 부제목 */
export const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 31px;
  color: ${({ theme }) => theme.colors.fontGray[400]};
  margin: 0;
  max-width: 800px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 16px;
    line-height: 24px;
    max-width: 100%;
  }
`;

/** 카드 제목 (h3) */
export const CardTitle = styled.h3`
  font-size: 24px;
  font-weight: 400;
  line-height: 31px;
  color: ${({ theme }) => theme.colors.fontBlackText};
  margin: 0;
`;

/** 모달 제목 (h2) */
export const ModalTitle = styled.h2`
  font-size: 26px;
  font-weight: 700;
  line-height: normal;
  color: ${({ theme }) => theme.colors.fontBlackText};
  margin: 0;
`;

/** 배너 히어로 제목 (h1) */
export const BannerTitle = styled.h1`
  font-size: 78px;
  font-weight: 700;
  line-height: normal;
  color: ${({ theme }) => theme.colors.fontWhite};
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 48px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 36px;
  }
`;

// ─────────────────────────────────────────────────────────────
// 텍스트 요소
// ─────────────────────────────────────────────────────────────

/** 레이블 텍스트 */
export const Label = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 100%;
  color: ${({ theme }) => theme.colors.fontBlackText};
`;

/** 에러 메시지 텍스트 */
export const ErrorText = styled.span`
  display: block;
  margin-top: 6px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.fontRedError};
`;

/** 대형 숫자 (통계, 카운터) */
export const LargeNumber = styled.span`
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  color: ${({ theme }) => theme.colors.fontBlackText};
`;
